import isUndefined from 'lodash/isUndefined'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import * as WebViewBridge from '@/checkout-instore-legacy/utils/WebViewBridge'

export function sendProxyConfigEvent() {
  const { proxy } = getInstoreConfig()

  if (!isUndefined(proxy)) {
    WebViewBridge.sendEvent({
      type: 'setProxyConfig',
      payload: { proxy },
    })
  }
}
